// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../vue3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../vue3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content-container[data-v-15913f02] {
  gap: 18px;
  height: 100%;
}
.registration-complete[data-v-15913f02] {
  flex: 1;
}
.header[data-v-15913f02] {
  margin: 0;
  margin-top: 16px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 24px;
}
.header-icon[data-v-15913f02] {
  font-size: 32px;
}
.form-input .header-icon[data-v-15913f02] {
  font-size: 32px;
}
em[data-v-15913f02] {
  color: #bbbbbb;
}
.navigation[data-v-15913f02] {
  list-style: none;
  gap: 8px;
  margin: 0;
  flex-direction: row;
  padding-left: 0;
}
.navigation-dot[data-v-15913f02] {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: #e4e4e4;
}
.registration-footer[data-v-15913f02] {
  margin-top: auto;
  gap: 30px;
  display: flex;
  flex-direction: column;
}
.pagination[data-v-15913f02] {
  width: 380px;
  padding-top: 28px;
  border-top: 1px solid #ebebeb;
}
.button-group[data-v-15913f02] {
  gap: 8px;
  padding: 0 32px;
}
`, "",{"version":3,"sources":["webpack://./../js/components/NewRegistration/WelcomeBack.vue"],"names":[],"mappings":";AA+DA;EACE,SAAS;EACT,YAAY;AACd;AAEA;EACE,OAAO;AACT;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;AAEA;EACE,QAAQ;EACR,eAAe;AACjB","sourcesContent":["<template>\r\n  <div\r\n    class=\"content-container d-flex justify-content-center align-items-center flex-column flex-1\"\r\n  >\r\n    <div class=\"registration-complete d-flex justify-content-center align-items-center flex-column\">\r\n      <em class=\"primaryicon-pre-approved-tick header-icon\" />\r\n      <p class=\"header\">\r\n        Welcome back{{ userDetails.firstName ? `, ${userDetails.firstName}!` : \"!\" }}\r\n      </p>\r\n      <p class=\"text-center\">\r\n        You are already a customer and do not need to signup for a new account. We have\r\n        automatically logged you in with your phone number. Please continue shopping with\r\n        confidence!\r\n      </p>\r\n    </div>\r\n    <div class=\"registration-footer\">\r\n      <div class=\"d-flex justify-content-center pagination\">\r\n        <ul class=\"d-flex navigation\">\r\n          <li class=\"navigation-dot\" />\r\n          <li class=\"navigation-dot bg-primary\" />\r\n        </ul>\r\n      </div>\r\n      <div class=\"d-flex justify-content-between button-group\">\r\n        <button\r\n          class=\"w-100 btn bgcolor-primary color-white submit-button btn-websites button-primary rounded-corners\"\r\n          @click=\"onDoneClick\"\r\n        >\r\n          Done\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  props: {\r\n    userDetails: {\r\n      required: true,\r\n      default: () => ({}),\r\n      type: Object,\r\n    },\r\n  },\r\n  data() {\r\n    return {\r\n      isLandingPage: window.parent.location.pathname === \"/\",\r\n      isSignPage: window.parent.location.pathname === \"/signin\",\r\n    };\r\n  },\r\n  methods: {\r\n    onDoneClick() {\r\n      if (this.isLandingPage || this.isSignPage) {\r\n        window.location.href = \"/mygarage\";\r\n      } else {\r\n        this.$emit(\"close-popup\");\r\n        window.location.reload();\r\n      }\r\n    },\r\n  },\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.content-container {\r\n  gap: 18px;\r\n  height: 100%;\r\n}\r\n\r\n.registration-complete {\r\n  flex: 1;\r\n}\r\n\r\n.header {\r\n  margin: 0;\r\n  margin-top: 16px;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.header-icon {\r\n  font-size: 32px;\r\n}\r\n\r\n.form-input .header-icon {\r\n  font-size: 32px;\r\n}\r\n\r\nem {\r\n  color: #bbbbbb;\r\n}\r\n\r\n.navigation {\r\n  list-style: none;\r\n  gap: 8px;\r\n  margin: 0;\r\n  flex-direction: row;\r\n  padding-left: 0;\r\n}\r\n\r\n.navigation-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background: #e4e4e4;\r\n}\r\n\r\n.registration-footer {\r\n  margin-top: auto;\r\n  gap: 30px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pagination {\r\n  width: 380px;\r\n  padding-top: 28px;\r\n  border-top: 1px solid #ebebeb;\r\n}\r\n\r\n.button-group {\r\n  gap: 8px;\r\n  padding: 0 32px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
